import { api } from 'cssapi'
import React from 'react'
import styled from 'styled-components'
import fixAspectRatio from '../styles/mixins/fixAspectRatio'

const Layout = styled.div`
  ${fixAspectRatio(242, 134)};

  /* Have to use an id instead of a classname as SVG doesn't support classes
  for targeting gradients */
  #logoGrad {
    .gradientStart {
      ${api({
        color: `c:backgroundInverted`,
      })};
    }

    .gradientEnd {
      ${api({
        color: `c:backgroundInverted`,
      })};
    }
  }

  svg path {
    fill: url(#logoGrad);
  }
`

const Logo = () => (
  <Layout>
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      preserveAspectRatio="xMinYMin meet"
      xmlSpace="preserve"
      viewBox="0 0 1500 1500"
      fillRule="nonzero"
    >
      <title>Skull Logo</title>
      <defs>
        <linearGradient id="logoGrad">
          <stop offset="0" className="gradientStart" />
          <stop offset="1" className="gradientEnd" />
        </linearGradient>
      </defs>
      <g>
        <path
          className="st0"
          d="M750,74.1c0-0.2,0-0.3,0-0.3S750,73.9,750,74.1L750,74.1z"
        />
        <path
          className="st1"
          d="M750,73.8L750,73.8L750,73.8L750,73.8L750,73.8z"
        />
        <path className="st1" d="M747.7,0L747.7,0L747.7,0L747.7,0z" />
        <path
          className="st1"
          d="M750,73.8C749.9,73.8,749.9,73.8,750,73.8L750,73.8C749.9,73.8,749.9,73.8,750,73.8L750,73.8z"
        />
        <path className="st1" d="M747.8,0L747.8,0L747.8,0L747.8,0z" />
        <path
          className="st1"
          d="M747.9,0L747.9,0C748,0,748,0,747.9,0C748,0,748,0,747.9,0z"
        />
        <path className="st1" d="M747.6,0L747.6,0L747.6,0L747.6,0z" />
        <path className="st1" d="M747.4,0L747.4,0L747.4,0L747.4,0z" />
        <path
          className="st1"
          d="M747.7,0C747.6,0,747.6,0,747.7,0C747.6,0,747.6,0,747.7,0L747.7,0z"
        />
      </g>
      <g>
        <path d="M1494,916.4c-190.1,25.6-355.9,60.8-497.5,105.7c62.4,72.1,101.1,140.3,115.9,204.7c-16.2,57.7-41,103.7-74.4,138.2
		c-33.4,34.5-81.6,67.3-144.6,98.5c-54.3-86.9-134.7-191.4-241.3-313.6c-142.1,66-265.9,141.1-371.3,225.1
		c-77.9-61.4-118.2-149.4-121-264.1c66-78.3,150.2-149.9,252.6-214.9C243.1,725,107.6,607.6,6,543.5
		c94.1-216.7,231-316.2,410.7-298.8c53.1,72.9,115.3,169.6,186.5,290.2c19.6-128.3,28.9-294.4,27.9-498.3
		c86.7-0.4,173.6,14.5,260.6,44.6s153,76.1,198.2,137.9c-41.1,123.1-94,258.9-158.8,407.5c202.8-97,307.6-146.9,314.4-149.9
		C1411,575.2,1493.8,721.7,1494,916.4z"
        />
      </g>
    </svg>
  </Layout>
)

export default Logo



// WEBPACK FOOTER //
// ./src/components/shared/StarLogo.jsx